export const GET_EDOK_FORM_BY_MODULE_SUCCESS = 'GET_EDOK_FORM_BY_MODULE_SUCCESS';

export const getEdokFormByModuleSuccess = form => ({
    type: GET_EDOK_FORM_BY_MODULE_SUCCESS,
    payload: { form },
});
